import { GetStaticProps } from 'next';
import { ClearInNavbar } from '../../../../components/Navbar/ClearNavbar';
import { banner_html_content } from '../../../../components/banner_html/banner_html';
import { b2cData } from '../../../../components/cms/layout/components/header';
import GlossaryIndex from '../../../../components/glossary_v2/components/IndexPage';
import GlossaryPageDataService from '../../../../components/glossary_v2/services/glossar.service';
import { TListCardProps } from '../../../../components/glossary_v2/utils/types';
import { IndexPathGenSlug } from '../../../../components/glossary_v2/utils/utils';
import {
  DOMAIN_PREFIX,
  domainCode,
} from '../../../../constants/staticPageConstants';
import { Meta } from '../../../../layout/Meta';
import { render404Page } from '../../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';

interface TListPageProps {
  data: TListCardProps[];
  queryParam: string;
}

const ListPage = ({ queryParam, data }: TListPageProps): JSX.Element => {
  return (
    <>
      <ClearInNavbar data={b2cData} />
      <Meta
        title="FinTech Glossary - The Complete Financial Guide - ClearTax"
        description="FinTech Glossary is a complete financial guide to understanding the FinTech terms like taxation, personal finance, investments, trading, economy, and more."
        canonical="https://cleartax.in/glossary"
      />
      <div
        className="bannerFromHTML"
        dangerouslySetInnerHTML={{ __html: banner_html_content }}
      />
      <GlossaryIndex
        domain={DOMAIN_PREFIX[domainCode.cleartaxIn]?.domain}
        data={data}
        queryParam={queryParam}
      />
    </>
  );
};

export const getStaticPaths = async () => {
  if (process.env.DEPLOYMENT_DOMAIN !== 'cleartax.in') {
    return {
      paths: [],
      fallback: false,
    };
  }
  if (process.env.ENABLE_GLOSSARY_PAGES === 'true') {
    const paths = IndexPathGenSlug();
    return {
      paths: [...paths],
      fallback: true,
    };
  }

  return {
    paths: [],
    fallback: false,
  };
};
export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  async ({ params }: { params: { slug: [string, string] } }) => {
    if (params?.slug.length <= 2 && params?.slug.length > 0) {
      const pageData = await GlossaryPageDataService.getIndexPages(
        params.slug[0],
        domainCode.cleartaxIn
      );

      const response = await pageData.data;
      return {
        props: {
          queryParam: params.slug[0].toLocaleLowerCase(),
          data: response,
        },
      };
    }
    return render404Page();
  }
);

export default ListPage;
